import { InfiniteData, QueryClient } from '@tanstack/react-query';
import {
  PlotFeature,
  PlotPageResult,
  ZoningStatus,
} from '@lidea/shared/util/types';

import { plotKeys } from '../../keys/plot-keys';

function resetPlotFeature(plot: PlotFeature): PlotFeature {
  const analysis = plot.properties.analyzes[0];
  if (!analysis) {
    return plot;
  }

  const { zoning: _zoning, ...analysisWithoutZoning } = analysis;

  return {
    ...plot,
    properties: {
      ...plot.properties,
      computed_yield: null,
      estimatedYield: null,
      yield_doses: null,
      percentYield: null,
      objYield: plot.properties.objYield,
      analyzes: [
        {
          ...analysisWithoutZoning,
          status: ZoningStatus.ToBeDone,
          summary: [],
        },
      ],
    },
  };
}

export function patchPlotCachesAfterReset(
  queryClient: QueryClient,
  plotId: number,
  campaignId: number | null | undefined
) {
  const detailKey = plotKeys.detail(plotId, campaignId).queryKey;

  queryClient.setQueryData<PlotFeature | undefined>(
    detailKey,
    (current: PlotFeature | undefined) =>
      current ? resetPlotFeature(current) : current
  );

  queryClient.setQueriesData<InfiniteData<PlotPageResult>>(
    { queryKey: plotKeys.searches(campaignId) },
    (current) => {
      if (!current) {
        return current;
      }

      return {
        ...current,
        pages: current.pages.map((page) => ({
          ...page,
          results: {
            ...page.results,
            features: page.results.features.map((feature: PlotFeature) =>
              feature.id === plotId ? resetPlotFeature(feature) : feature
            ),
          },
        })),
      };
    }
  );
}
